import React from 'react'
import UserProfile from '../../myapp/Profile/UserProfile'

function UserProfilePage() {
  return (
    <UserProfile/>
  )
}

export default UserProfilePage